export default [
  {
    fontFamily: 'SFProText-Regular',
    name: 'SFProTextRegular',
    src: `local('SFProText-Regular'), url('/assets/fonts/SFProText-Regular.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFProText-Bold',
    name: 'SFProTextBold',
    src: `local('SFProText-Bold'), url('/assets/fonts/SFProText-Bold.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFProText-Semibold',
    name: 'SFProTextSemibold',
    src: `local('SFProText-Semibold'), url('/assets/fonts/SFProText-Semibold.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFProText-Medium',
    name: 'SFProTextMedium',
    src: `local('SFProText-Medium'), url('/assets/fonts/SFProText-Medium.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFProText-Light',
    name: 'SFProTextLight',
    src: `local('SFProText-Light'), url('/assets/fonts/SFProText-Light.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFUIText-Regular',
    name: 'SFUITextRegular',
    src: `local('SFUIText-Regular'), url('/assets/fonts/SFUIText-Regular.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFUIText-Medium',
    name: 'SFUITextMedium',
    src: `local('SFUIText-Medium'), url('/assets/fonts/SFUIText-Medium.ttf') format('truetype')`,
  },
  {
    fontFamily: 'SFProDisplay-BlackItalic',
    name: 'SFProDisplayBlackItalic',
    src: `local('SFProDisplay-BlackItalic'), url('/assets/fonts/SFProDisplay-BlackItalic.ttf') format('truetype')`,
  },
];
